module.exports = __webpack_public_path__ + "img/placeholder.9c5f578f.jpg";